export const cx = (condition, className) => {
  if (!condition) return ''
  return className
}